import { render } from "./DeletedUsers.vue?vue&type=template&id=613b704c&scoped=true"
import script from "./DeletedUsers.vue?vue&type=script&lang=js"
export * from "./DeletedUsers.vue?vue&type=script&lang=js"

import "./DeletedUsers.vue?vue&type=style&index=0&id=613b704c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613b704c"]])

export default __exports__